<template>
  <b-container>
    <b-row style="padding-top: 24px">
      <b-col md="3">
        <div>
          <b-form-group>
            <label style="padding-bottom: 4px">City Code</label>
            <b-form-input placeholder="City Code" v-model="searchParams.cityCode" />
          </b-form-group>

          <b-form-group style="padding-top: 16px">
            <label style="padding-bottom: 4px">Hotel Name</label>
            <b-form-input
              placeholder="Name"
              v-model="searchParams.hotelName"
              @keydown.enter.native="handleSearch"
            />
          </b-form-group>

          <div style="margin-top: 12px; display: flex">
            <b-button variant="primary" style="flex: 1" @click="handleSearch">
              Search
            </b-button>
          </div>
        </div>
      </b-col>

      <b-col>
        <div v-if="isLoading" class="text-center">
          <b-spinner />
        </div>

        <div v-if="this.errorMessage">
          <h3 style="color: red">{{ this.errorMessage }}</h3>
        </div>

        <div v-if="this.hotels.length > 0">
          <h3>Search Results</h3>

          <div
            v-for="d in this.hotels"
            :key="d.hotel.hotelId"
            style="margin-bottom: 16px"
          >
          <hr>
            <div style="font-weight: bold">
              {{ d.hotel.name }}
            </div>

            <div style="font-size: 14px">
              {{ d.hotel.hotelId }}
            </div>

            <div style="font-size: 14px">
              <div v-for="line in d.hotel.address.lines" :key="line">
                {{ line }}
              </div>
              {{ `${d.hotel.address.cityName}, ${d.hotel.address.countryCode}` }}
            </div>

            <b-button
              variant="success"
              style="flex: 1; font-size: 14px; font-weight: bold"
              @click="handleAdd(d.hotel)"
            >
              Add to Database
            </b-button>

            <div>
              <img
                :src="
                  d.hotel.media && d.hotel.media.length > 0 ? d.hotel.media[0].uri : ''
                "
                style="max-height: 300px; max-width: 100%; margin: 4px 0px 0px 0px"
              />
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      allHotels: [],
      hotels: [],
      searchParams: {},
      searchText: "",
      isLoading: false,
      selectedHotelImage: [],
      errorMessage: null,
    };
  },
  mounted() {
    // this.fetchHotels();
  },
  methods: {
    async handleAdd(hotel) {
      console.log(hotel);
      this.isLoading = true;
      try {
        const response = await fetch("/hotel/add", {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(hotel),
        });

        this.$bvToast.toast(`${hotel.name} added to database.`, {
          title: `Hotel Added`,
          autoHideDelay: 5000,
          variant: "success",
            solid: true,
        });
      } catch (e) {
        console.error(e);
      }

      this.isLoading = false;
    },
    async handleSearch() {
      try {
        this.errorMessage = null;
        this.isLoading = true;
        this.hotels = [];
        const response = await fetch("/hotels/search", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.searchParams),
        });

        const json = await response.json();
        this.hotels = json.data;
        console.log(this.hotels);
      } catch (e) {
        console.log(e);
        this.errorMessage = "Search failed";
      }

      this.isLoading = false;
    },
    async handleSave() {
      const url = `/hotel/update`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(this.selectedHotel),
      });

      this.fetchHotels();
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/HotelSearch.vue